<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mt-1 mb-3">Solicitações Realizadas</h5>
            <TableLiberacao/>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import TableLiberacao from '@/router/views/admin/components/table-liberacao'
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Solicitações",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    TableLiberacao
  },
  data() {
    return {
      title: "Solicitações",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Solicitações',
          active: true,
        },
      ],
    };
  },
  mounted() {
  },
};
</script>


